import React from 'react';

interface DifficultyBadgeProps {
  difficulty: 'easy' | 'medium' | 'hard';
  className?: string;
}

/**
 * A reusable badge component to display difficulty levels with appropriate colors
 */
const DifficultyBadge: React.FC<DifficultyBadgeProps> = ({ 
  difficulty, 
  className = ''
}) => {
  // Get the appropriate color classes based on difficulty level
  const colorClasses = 
    difficulty === "easy"
      ? "bg-green-100 dark:bg-green-700/30 text-green-600 dark:text-green-400"
      : difficulty === "medium"
      ? "bg-yellow-100 dark:bg-yellow-700/30 text-yellow-600 dark:text-yellow-400"
      : "bg-red-100 dark:bg-red-700/30 text-red-600 dark:text-red-400";
  
  // Format the difficulty text (capitalize first letter)
  const formattedText = difficulty.charAt(0).toUpperCase() + difficulty.slice(1);
  
  return (
    <span
      className={`inline-flex font-medium rounded-full text-center px-2.5 py-0.5 ${colorClasses} ${className}`}
    >
      {formattedText}
    </span>
  );
};

export default DifficultyBadge;
